import { useState } from 'react';
import { ContentType } from 'core/flow/entities/Appearance';
import { useQuizStep } from 'core/funnel/contexts';
import { Sidebar } from '../../Sidebar';
import { ButtonBack } from '../ButtonBack';
import { ButtonMenu } from '../ButtonMenu';
import { Logo } from '../Logo';
import { ProgressBar } from '../ProgressBar';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { HeaderStyled } from './styled';

type HeaderProps = {
  screenId: string;
};

export const Header = ({ screenId }: HeaderProps) => {
  // TODO check usage another hook more appropriate
  const { back } = useQuizStep(screenId);
  const { contentType, currentStepIndex, progressBarSteps, hasPrevPath, isHeaderHidden } =
    useCurrentStep(screenId);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  if (isHeaderHidden) return null;

  return (
    <>
      {contentType === ContentType.LOGO ? (
        <HeaderStyled>
          <ButtonBack onBack={back} hasPrevPath={hasPrevPath} />
          <Logo />
          <ButtonMenu onClick={toggleSidebar} />
        </HeaderStyled>
      ) : (
        <>
          <HeaderStyled>
            <ButtonBack onBack={back} hasPrevPath={hasPrevPath} />
            <Logo />
            <ButtonMenu onClick={toggleSidebar} />
          </HeaderStyled>
          <ProgressBar currentStep={currentStepIndex} steps={progressBarSteps} />
        </>
      )}

      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
    </>
  );
};
